import React, { FC, useState } from 'react';

import { ChevronDownIcon } from '../../../assets/icons/index';
import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
} from '../../../components/combobox/index';
import { useLocale } from '../../../hooks/index';
import { VestingOnOption, VestingOnTitle } from '../../../types/pool-plans.types';

const VestingOnItemsList = () => {
  return (
    <>
      {Object.entries(VestingOnTitle).map(([key, value]) => (
        <ComboboxOption key={key} value={key}>
          <span className="text-sm text-gray-700">{<AppFormattedMessage id={value} />}</span>
        </ComboboxOption>
      ))}
    </>
  );
};

export type VestingOnComboboxProps = {
  defaultValue?: VestingOnOption;
  onSelect?: (state: VestingOnOption) => void;
};

export const VestingOnCombobox: FC<VestingOnComboboxProps> = ({ onSelect, defaultValue }) => {
  const [value, setValue] = useState<null | VestingOnOption>(defaultValue ?? null);
  const { messagesLocale } = useLocale();
  return (
    <Combobox
      as={'div'}
      className="relative w-[200px]"
      onChange={(state: VestingOnOption) => {
        onSelect?.(state);
        setValue(state);
      }}
    >
      <div className="relative">
        <ComboboxInput
          className={'bg-gray-900'}
          icon={<ChevronDownIcon className="mt-2" />}
          onChange={() => ''}
          placeholder={<AppFormattedMessage id="VESTING" />}
          readOnly
          value={value ? messagesLocale[VestingOnTitle[value]] : value || ''}
        />
        <ComboboxButton className="absolute left-0 top-0 z-1 h-full w-full" />
      </div>
      <ComboboxOptions className="w-full">
        <VestingOnItemsList />
      </ComboboxOptions>
    </Combobox>
  );
};
